import { BrickContext, VisualBrick, registerBrick } from 'olympe';
import * as d3 from 'd3';
import { combineLatest } from 'rxjs';

type Properties = [
    obj: object,
    name: string,
    timespan: string,
];

export default class PieChart extends VisualBrick {
    protected setupExecution($: BrickContext) {
        const observeData = $.observe('obj');
        const observeName = $.observe('name');
        const observeTS = $.observe('timespan');

        console.log("setupExecution()");
        
        return combineLatest([
          observeData,
          observeName,
          observeTS,
        ]);

    }
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {!Array<*>} properties
     * @return {Element}
     */
    render($: BrickContext, [obj, name, timespan]: Properties) {
        // Write your code here. This method must return a DOM element.
        // If using React take a look at the ReactBrick class.
        // Check https://olympe.support for documentation.
        // Check https://github.com/olympeio/CORE for examples.
        //
        // This method is executed only once by default.
        // Override `setupExecution()` to change the behavior and control the `properties` parameter.

        // Create the color scale.
        const color = {
          "NOMINAL": d3.color("#B4E0A7"),
          "WARN": d3.color("#F1CF63"),
          "ANOMALY": d3.color("#E1575A"),
          "UNKNOWN": d3.color("#BBB1AC")
        }

        // Create data for visualization
        const data = [];
        for (const [key, value] of Object.entries(color)) {
          data.push({"name": key, "value": obj[key+timespan]})
        }

        // Specify the chart’s dimensions.
        const height: number = $.get("Height");
        const width: number = $.get("Height");


        // Create the pie layout and arc generator.
        const pie = d3.pie()
            .sort(null)
            .value(d => d.value);

        const arc = d3.arc()
            .innerRadius(0)
            .outerRadius(Math.min(width, height) / 2 - 1);

        const labelRadius = arc.outerRadius()() * 0.5;

        // A separate arc generator for labels.
        const arcLabel = d3.arc()
            .innerRadius(labelRadius)
            .outerRadius(labelRadius);

        const arcs = pie(data);

        // Create the SVG container.
        const svg = d3.create("svg")
            .attr('class', "pie-" + name)
            .attr("width", width)
            .attr("height", height)
            .attr("viewBox", [-width / 2, -height / 2, width, height])
            .attr("style", "max-width: 100%; height: auto; font: 10px sans-serif;");

        // Add a sector path for each value.
        svg.append("g")
            .attr("stroke", "white")
          .selectAll()
          .data(arcs)
          .join("path")
            .attr("fill", d => color[d.data.name])
            .attr("d", arc)
          .append("title")
            .text(d => `${d.data.name}: ${d.data.value.toLocaleString("en-US")}`);

        // Create a new arc generator to place a label close to the edge.
        // The label shows the value if there is enough room.
        svg.append("g")
          .attr("text-anchor", "middle")
          .selectAll()
          .data(arcs);

        return svg.node();
        /*
        // We create a DIV html element
        const element = document.createElement('div');
        element.innerHTML = "qwe123";

        // Return the element to render
        return element;
        */
    }
}

registerBrick('01906d6eca8da84bbeab', PieChart);
